export const BETTO_ALERT_ILLUSTRATION_LOADERS = {
	"bet-confirmed": () => import("./assets/bet-confirmed.png"),
	"deposit-completed": () => import("./assets/deposit-completed.png"),
	"incorrect-password": () => import("./assets/incorrect-password.png"),
	"insufficient-funds": () => import("./assets/insufficient-funds.png"),
	"invalid-verification-code": () => import("./assets/invalid-verification-code.png"),
	"low-wallet-balance": () => import("./assets/low-wallet-balance.png"),
	"password-updated": () => import("./assets/password-updated.png"),
	"payment-failed": () => import("./assets/payment-failed.png"),
	"profile-updated": () => import("./assets/profile-updated.png"),
	"request-submitted": () => import("./assets/request-submitted.png"),
	"session-expire": () => import("./assets/session-expire.png"),
	"something-went-wrong": () => import("./assets/something-went-wrong.png"),
	"too-many-login-attempts": () => import("./assets/too-many-login-attempts.png"),
	"transaction-failed": () => import("./assets/transaction-failed.png"),
	"verification-complete": () => import("./assets/verification-complete.png"),
	"welcome-platform": () => import("./assets/welcome-platform.png"),
};
